<template>
  <div>
    <div class="e-card" v-if="!isSubmitted">
      <div class="e-card-title">{{ pageTitle }}</div>
      <div class="e-card-separator"></div>
      <div class="e-card-content">
        <div>
          <span class="error-container">
            {{ erorrMessage }}
          </span>
        </div>
        <form class="login" @submit.prevent="verifyEmail">
          <scc-input-validator
            :rules="[requiredRule, emailRule]"
            :value="this.email"
            @validate="(v) => (this.isEmailValid = v)"
          >
            <ejs-textbox
              float-label-type="Always"
              placeholder="Enter Email"
              v-model="email"
            />
          </scc-input-validator>
          <re-captcha>
            <div class="align-bottom">
              <ejs-button type="submit" cssClass="e-info margin-button">
                Verify Email
              </ejs-button>
            </div>
          </re-captcha>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import SccInputValidator from '@/components/base/scc-input-validator.vue';
import ReCaptcha from '@/components/re-captcha.vue';
import { emailRule, requiredRule } from '@/shared/constants';

export default {
  name: 'EmailValidation',
  components: {
    SccInputValidator,
    ReCaptcha,
  },
  props: {
    pageTitle: {
      type: String,
      required: true,
    },
    erorrMessage: {
      type: String,
      default: '',
    },
    isSubmitted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      email: null,
      requiredRule,
      emailRule,
      isEmailValid: false,
    };
  },
  methods: {
    validateEmail() {
      this.email = this.email === null ? '' : this.email;
    },
    verifyEmail() {
      this.$emit('submit', this.email);
    },
  },
};
</script>

<style>
.error-container {
  color: red;
  display: block;
  margin-bottom: 2%;
}
.e-card-title {
  background: #0f4b90;
  color: white;
  font-weight: 500;
}
.e-card-content {
  text-align: left;
  /* height: 400px; */
  /* margin: 5%; */
}
.margin-color-verify-section {
  margin: 2% !important;
  color: currentColor !important;
}
.e-btn.e-info, .e-css.e-btn.e-info {
  background-color: #dba832 !important;
  color: white !important;
}

.align-bottom {
  display: block;
  text-align: center;
  margin: 25px 5px 20px 20px;
}
</style>
